import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initializeOneSignal } from "./services/onesignal";
import { initBiometricCallbacks } from "./hooks/useBiometricAuth";
import { initMetaPixel, trackAppLaunch } from "./utils/metaTracking";

// Initialize OneSignal before React renders
const ONESIGNAL_APP_ID = import.meta.env.VITE_ONESIGNAL_APP_ID;
if (ONESIGNAL_APP_ID) {
  initializeOneSignal(ONESIGNAL_APP_ID).then((success) => {
    if (success) {
      console.log('[App] OneSignal initialized successfully');
    }
  });
}

// Initialize biometric authentication callbacks
initBiometricCallbacks();

// Initialize Meta Pixel and track app launch
initMetaPixel();
trackAppLaunch();

createRoot(document.getElementById("root")!).render(<App />);
